import axios from "axios";
import { logOutUser, logOutCompany, setSessionKey } from '../helpers/commonFunctions';
import Swal from "sweetalert2";

const axiosCommon = (history = null) => {
  const token = localStorage.getItem("company_token") || localStorage.getItem("token");
  const baseURL = process.env.REACT_APP_SUPER_ADMIN_APIS_BASE_URL;

  let headers = { Authorization: `Bearer ${token}` };

  const axiosInstance = axios.create({
    baseURL: baseURL,
    headers,
  });

  axiosInstance.interceptors.response.use(
    (response) => new Promise((resolve) => { resolve(response); }),
    (error) => {
      console.error("axiosCommon error -----> ", error);

      if (error.response.status === 401) {
        setSessionKey("session_expired", "true");
        Swal.fire({
          customClass: 'swal-wide',
          icon: 'error',
          title: error?.response?.data?.errors?.message || error?.message,
          showConfirmButton: false,
          timer: 1000,
          toast: true,
          position: 'top-right',
        });
        // setTimeout(() => {
        //   if (localStorage.getItem("company_token")) {
        //     logOutCompany();
        //   } else {
        //     logOutUser();
        //   }
        // }, 1000);
      } else {
        Swal.fire({
          customClass: 'swal-wide',
          icon: 'error',
          title: error?.response?.data?.errors?.message,
          showConfirmButton: false,
          timer: 5000,
          toast: true,
          position: 'top-right',
        });
        return Promise.reject(error);
      }
    }
  );

  return axiosInstance;
};

export default axiosCommon;
